export default __webpack_public_path__ + "static/media/icon-18.2acf6555.png";